/**
 * Returns true when running on the admin subdomain (admin.printmyparts.io).
 * Set VITE_ADMIN_MODE=true in .env.local to test admin UI locally.
 */
export function isAdminHost(): boolean {
    const h = window.location.hostname;
    return (
        h === 'admin.printmyparts.io' ||
        h === 'admin.localhost' ||
        import.meta.env.VITE_ADMIN_MODE === 'true'
    );
}
